import { TextField, Autocomplete } from "@mui/material";
import React from "react";
import { Account } from "@api";
import { LoadingProgressBar, LoadingSpinner } from "@components";

export interface Props {
  loading: boolean;
  accounts: Account[];
  selectedAccount: Account | null;
  placeholder: string;
  testId?: string;
  onSelect: (account: Account) => void;
}

export const AccountSelector = ({
  loading,
  accounts,
  selectedAccount,
  placeholder,
  testId,
  onSelect,
}: Props) => {
  const getOptionLabel = (account: Account) =>
    `${account.name} ${account.bankName ? " - " + account.bankName : ""}`;

  const handleSelect = (account: Account | null) => {
    if (!onSelect || !account) return;
    onSelect(account);
  };

  if (loading) {
    return <LoadingProgressBar />;
  }
  return (
    <Autocomplete
      getOptionLabel={getOptionLabel}
      loading={loading}
      value={selectedAccount}
      fullWidth
      options={accounts}
      autoHighlight
      onChange={(_: any, value: Account | null) => {
        handleSelect(value);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={placeholder}
          variant="outlined"
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <LoadingSpinner width={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
              autoComplete: "new-password", // disable autocomplete and autofill
            },

            htmlInput: {
              ...params.inputProps,
              "data-testid": testId ? testId : "account-selector",
            },
          }}
        />
      )}
    />
  );
};
